export default __webpack_public_path__ + "static/media/contribution.a2c6cc1c.svg";